"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRoleDTO = exports.RoleDTOSchema = exports.ajv = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-var-requires */ /* tslint:disable */
// generated by typescript-json-validator
const util_1 = require("util");
const ajv_1 = tslib_1.__importDefault(require("ajv"));
exports.ajv = new ajv_1.default({
    allErrors: true,
    coerceTypes: false,
    format: "fast",
    nullable: true,
    unicode: true,
    uniqueItems: true,
    useDefaults: true,
});
exports.ajv.addMetaSchema(require("ajv/lib/refs/json-schema-draft-06.json"));
exports.RoleDTOSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    defaultProperties: [],
    properties: {
        appUiPermissions: {
            additionalProperties: {
                items: {
                    enum: ["A", "C", "D", "M", "R", "S", "W"],
                    type: "string",
                },
                type: "array",
            },
            defaultProperties: [],
            type: "object",
        },
        description: {
            type: "string",
        },
        key: {
            type: "string",
        },
        labels: {
            items: {
                enum: [
                    "ACCOUNT_ADMIN",
                    "APP",
                    "CLIENT",
                    "CORE",
                    "DEVEL",
                    "EVAL",
                    "EXTERNAL",
                    "FULL_ACCESS",
                    "GRAPHIC",
                    "LEAD",
                    "LEGACY",
                    "LEGAL",
                    "MARKETING",
                    "MODULE_PROJECTS",
                    "MODULE_TASKS",
                    "MODULE_USER",
                    "ORG_ADMIN",
                    "PORTAL",
                    "PROGRAMMATIC",
                    "PUBLIC",
                    "READONLY",
                    "SALES",
                    "STORE",
                    "SUPPORT",
                    "UNIT_ADMIN",
                ],
                type: "string",
            },
            type: "array",
        },
        name: {
            type: "string",
        },
        portalUiPermissions: {
            additionalProperties: {
                items: {
                    enum: ["A", "C", "D", "M", "R", "S", "W"],
                    type: "string",
                },
                type: "array",
            },
            defaultProperties: [],
            type: "object",
        },
        rootDbPermissions: {
            additionalProperties: {
                items: {
                    enum: ["R", "RA", "RO", "W", "WA", "WO"],
                    type: "string",
                },
                type: "array",
            },
            defaultProperties: [],
            type: "object",
        },
        rootStoragePermissions: {
            additionalProperties: {
                items: {
                    enum: ["R", "RA", "RO", "W", "WA", "WO"],
                    type: "string",
                },
                type: "array",
            },
            defaultProperties: [],
            type: "object",
        },
    },
    required: ["labels", "name", "rootDbPermissions", "rootStoragePermissions"],
    type: "object",
};
exports.isRoleDTO = exports.ajv.compile(exports.RoleDTOSchema);
function validate(value) {
    if (exports.isRoleDTO(value)) {
        return value;
    }
    else {
        throw new Error(exports.ajv.errorsText(exports.isRoleDTO.errors.filter((e) => e.keyword !== "if"), { dataVar: "RoleDTO" }) +
            "\n\n" +
            util_1.inspect(value));
    }
}
exports.default = validate;
//# sourceMappingURL=Role.validator.js.map